import * as React from 'react';
import { useParams } from 'react-router';

import { EditTemplatePage } from '../pages/edit-template-page';
import { MembersContextProvider } from '../members-context';
import { OnboardingContextProvider } from '../onboarding.context';
import { PredictionsInfoContext } from '../../forecast/detail/context/predictions-info-context';
import { ReportsContextProvider } from '../reports.context';
import { TemplatesContextProvider } from '../templates.context';

export const TemplateContainer = () => {
  const { templateId } = useParams();
  const id = templateId || '';

  return (
    <PredictionsInfoContext>
      <MembersContextProvider>
        <ReportsContextProvider>
          <TemplatesContextProvider>
            <OnboardingContextProvider>
              <EditTemplatePage key={id} templateId={id} />
            </OnboardingContextProvider>
          </TemplatesContextProvider>
        </ReportsContextProvider>
      </MembersContextProvider>
    </PredictionsInfoContext>
  );
};
